import { render, staticRenderFns } from "./seeFileDetail.vue?vue&type=template&id=f0a2bdf6&scoped=true&"
import script from "./seeFileDetail.vue?vue&type=script&lang=js&"
export * from "./seeFileDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a2bdf6",
  null
  
)

export default component.exports